import { render } from "./FooterStatic.vue?vue&type=template&id=24602ea9"
import script from "./FooterStatic.vue?vue&type=script&lang=js"
export * from "./FooterStatic.vue?vue&type=script&lang=js"

import "./FooterStatic.vue?vue&type=style&index=0&id=24602ea9&lang=scss"

import exportComponent from "/Users/nicorivera/Documents/NR/Sate/sate2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__